import React from 'react'
import MultiAppointment from './MultiAppointment';
import AppointmentItem from './AppointmentItem';
import { get } from 'lodash';
import BlockHourItem from './BlockHourItem';
import { CalendarAppointment, BlockHour, CalendarDataItem } from 'types/models';

interface CalendarItemProps {
  data?: CalendarDataItem[];
  headerData?: unknown;
  disabled?: boolean;
  onViewAppointmentDetail?: (args: { id: string; disabled?: boolean }) => void;
}

const CalendarItem = ({ data = [], headerData, disabled, onViewAppointmentDetail }: CalendarItemProps) => {
  const aptList = data.filter((o): o is CalendarAppointment => o.type === 'apt');
  const blockHoursList = data.filter((o): o is BlockHour => o.type === 'block-hour');
  if (blockHoursList.length) {
    return <div className='calendar-item'>
      <BlockHourItem
        headerData={headerData}
        data={get(blockHoursList, [0])}
      />
    </div>
  }
  if (aptList.length) {
    return <div className='calendar-item'>
      {(aptList.length > 1 ?
        <MultiAppointment
          headerData={headerData}
          data={aptList}
          onViewAppointmentDetail={onViewAppointmentDetail}
        /> : <AppointmentItem
          single
          disabled={disabled}
          headerData={headerData}
          data={get(aptList, [0])}
          onViewDetail={onViewAppointmentDetail}
        />)}
    </div>
  }
  return null;
}

export default CalendarItem;
